import { TRANSACTION_TOTALS_CONSTANTS } from './actions/customer.totals.actions';
import Immutable from 'seamless-immutable';
export var INITIAL_STATE = Immutable({
  data: null,
  isFetchingData: null,
  totalsError: null
});
export default function productsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case TRANSACTION_TOTALS_CONSTANTS.BEGIN:
      return state.set('isFetchingData', true);
    case TRANSACTION_TOTALS_CONSTANTS.SUCCESS:
      return state.set('data', payload).set('isFetchingData', false).set('totalsError', null);
    case TRANSACTION_TOTALS_CONSTANTS.FAILURE:
      return state.set('isFetchingData', false).set('totalsError', {
        code: payload.Code,
        message: payload.translatedMessage,
        severity: payload.Severity
      });
    default:
      return state;
  }
}